import { CognitoUserAttribute } from 'amazon-cognito-identity-js'

export interface UserAttributes {
  sub: string
  email: string
  given_name: string
  family_name: string
  email_verified: string
  organization: string
}

export const convertUserAttributesListToLabels = (attributes: CognitoUserAttribute[]): UserAttributes =>
  attributes.reduce(
    (obj, item) =>
      Object.assign(obj, { [item.Name === 'custom:organization' ? 'organization' : item.Name]: item.Value }),
    {} as UserAttributes
  )
